// extracted by mini-css-extract-plugin
export default {"MenuToggle":"MenuToggle_MenuToggle__LPEop","open":"MenuToggle_open__Fx0AI"};